export default class customPlayer {

	static init() {
		// Var
		var internoBtn = document.getElementById("radio-a");
		var esternoBtn = document.getElementById("radio-b");
		if (!document.getElementById("audioSample")) return;
		var audio = new Audio();
		var canvas, ctx, source, context, analyser, fbc_array, bars, bar_x, bar_width, bar_height;

		var videoOutside = document.getElementById("video-outside");
		var videoInside = document.getElementById("video-inside");

		//Switch
		$(internoBtn).on("click", function () {
			$(videoInside).addClass('active');
			$(videoOutside).removeClass('active');
			//$(videoOutside).get(0).volume = 0;
			//$(videoInside).get(0).volume = 1;
			$(videoOutside)[0].muted = true;
			$(videoInside)[0].muted = false;
			$(this).addClass('active');
			$(esternoBtn).removeClass('active');
			//console.log('volume 0');
			//audio.volume = 1;
		});
		$(esternoBtn).on("click", function () {
			$(videoInside).removeClass('active');
			$(videoOutside).addClass('active');
			$(videoOutside)[0].muted = false;
			$(videoInside)[0].muted = true;
			$(this).addClass('active');
			$(internoBtn).removeClass('active');
			//audio.volume = 0.1;
			//console.log('volume 0.1');
		});

		//Audio
		audio.src = $('base').attr('href') + 'audio/office-sounds.mp3';
		audio.loop = true;
		document.getElementById('audioSample').appendChild(audio);



		// Analyzer
		var AudioContext = window.AudioContext // Default
			|| window.webkitAudioContext;// Safari and old versions of Chrome
		context = new AudioContext(); // AudioContext object instance
		analyser = context.createAnalyser(); // AnalyserNode method
		canvas = document.getElementById('analyser_render');
		ctx = canvas.getContext('2d');
		// Re-route audio playback into the processing graph of the AudioContext
		source = context.createMediaElementSource(audio);
		source.connect(analyser);
		analyser.connect(context.destination);
		frameLooper();
		// frameLooper() animates any style of graphics you wish to the audio frequency
		// Looping at the default frame rate that the browser provides(approx. 60 FPS)
		function frameLooper() {
			window.requestAnimationFrame(frameLooper);
			fbc_array = new Uint8Array(analyser.frequencyBinCount);
			analyser.getByteFrequencyData(fbc_array);
			ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
			ctx.fillStyle = '#4C5157'; // Color of the bars
			bars = 100;
			for (var i = 0; i < bars; i++) {
				bar_x = i * 3;
				bar_width = 1;
				bar_height = -(fbc_array[i] / 2);
				//  fillRect( x, y, width, height ) // Explanation of the parameters below
				ctx.fillRect(bar_x, canvas.height, bar_width, bar_height);
			}
		}


		// One-liner to resume playback when user interacted with the page.
		/*document.querySelector('#play-btn').addEventListener('click', function() {
			context.resume().then(() => {
				console.log('Playback resumed successfully');
				$('.equalizer img').hide().fadeOut(2000);

				//audio.play();
			});
		});*/

		$("#play-btn").on("click", function () {
			$(this).addClass('active');
			$("#pause-btn").removeClass('active');
			$(videoOutside)[0].muted = false;
			$(videoInside)[0].muted = true;
			$(videoOutside).get(0).play();
			$(videoInside).get(0).play();
			
			//audio.play();
		});

		$("#pause-btn").on("click", function () {
			$(this).addClass('active');
			$("#play-btn").removeClass('active');
			$(videoOutside).get(0).pause();
			$(videoInside).get(0).pause();
			//$('.equalizer img').hide().fadeIn(2000);
			//audio.pause();
		});

	}

}
